import { clsx } from "clsx";
import { Handle, Position } from "reactflow";

import styles from "./NodeHandles.module.scss";

// handles are used by react-flow to connect edges. it checks in mouse up event if element bellow is valid
// default handle size is small, so it requires to be very precise when connecting nodes
// We increase the handle container's size to make the click target easier to use.

type NodeHandleProps = {
    isConnectable: boolean;
};

type MultiHandleProps = NodeHandleProps & {
    id?: string;
};

export function TopHandle({ isConnectable }: NodeHandleProps): JSX.Element {
    return (
        <Handle
            type="target"
            position={Position.Top}
            className={styles.handleContainer}
            isConnectable={isConnectable}
            data-testid="top-handle"
        >
            <div className={styles.actualHandle}></div>
        </Handle>
    );
}

export function BottomHandle({ isConnectable, id }: MultiHandleProps): JSX.Element {
    return (
        <Handle
            id={id}
            type="source"
            position={Position.Bottom}
            className={styles.handleContainer}
            isConnectable={isConnectable}
            data-testid="bottom-handle"
        >
            <div className={styles.actualHandle}></div>
        </Handle>
    );
}

export function LeftHandle({ isConnectable }: NodeHandleProps): JSX.Element {
    return (
        <Handle
            type="target"
            position={Position.Left}
            className={clsx(styles.handleContainer, styles.horizontal)}
            isConnectable={isConnectable}
            data-testid="left-handle"
        >
            <div className={styles.actualHandle}></div>
        </Handle>
    );
}

export function RightHandle({ isConnectable, id }: MultiHandleProps): JSX.Element {
    return (
        <Handle
            id={id}
            type="source"
            position={Position.Right}
            className={clsx(styles.handleContainer, styles.horizontal)}
            isConnectable={isConnectable}
            data-testid="right-handle"
        >
            <div className={styles.actualHandle}></div>
        </Handle>
    );
}
